import { useState, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '@reducers/index';
import { KeywordInsightGridOption } from '@classes/options/grid/keyword/keywordInsight';
import { fetchKeywordAddDel } from '@reducers/keyword/thunk/insightThunk';
import GridAtom from '@components/atom/grid/grid';

//TODO: 내일은 옵션부터... add/Del 버튼 작업하기
const GridComponent = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { keywordList } = useSelector(({ keywordInsight }: RootState) => keywordInsight);

  const [gridData, setGridData] = useState(null);

  useEffect(() => {
    if (keywordList) {
      console.log('keywordList: ', keywordList);
      setGridData(new KeywordInsightGridOption().insightBox(keywordList, addDelHandler));
    }
  }, [keywordList]);

  const addDelHandler = useCallback(
    (keywordObj) => {
      const { keyword, currentTracked } = keywordObj;
      dispatch(
        fetchKeywordAddDel({
          keyword: keyword,
          reqType: !currentTracked ? 'add' : 'del',
          userId: 'SS',
        })
      );
    },
    [dispatch, fetchKeywordAddDel]
  );

  return (
    <>
      {keywordList && (
        <div className="table-api-wrap">
          <div className="tbl-wrap">
            <GridAtom {...gridData} height="590px" />
          </div>
        </div>
      )}
    </>
  );
};

export default GridComponent;
